module.exports = __webpack_public_path__ + "img/document.35ba8e7f.svg";